import { $ } from '../utils/jquery.js';
import globalOptions from "./globalOptions";

$.fn.accordionToggle = function (hide) {
  const accordion = this;
  const content = accordion.find(".js-accordion-content");
  const isSingle = accordion.data("accordion-single");
  const isActive = accordion.hasClass("is-active");
  const isDisabled = accordion.hasClass("is-disabled");
  const siblings = accordion.siblings(".js-accordion.is-active");

  if (isDisabled || hide !== isActive) return;

  if (hide) {
    accordion.removeClass("is-active");
    content.slideUp(globalOptions.animationDuration);

    setTimeout(() => {
      accordion.removeClass("is-active-initial");
    }, globalOptions.animationDuration);
  } else {
    accordion.addClass("is-active");
    content.slideDown(globalOptions.animationDuration);

    if (isSingle) {
      siblings.accordionToggle(true);
    }
  }
};


$(document).on("click", ".js-accordion-button", function (e) {
  if (e.target.tagName === "a") {
    e.preventDefault();
  }

  const accordion = $(this).closest(".js-accordion");
  const isActive = accordion.hasClass("is-active");

  if (isActive) {
    accordion.accordionToggle(true);
    return;
  }

  accordion.accordionToggle(false);
});

// js-product-options__active-item
// show accordion on mouse hover
$(document).on("mouseover", ".js-product-options__active-item", function (e) {
  if (e.target.tagName === "a") {
    e.preventDefault();
  }

  const accordion = $(this).closest(".js-accordion");
  const isActive = accordion.hasClass("is-active");

  if (isActive) {
    accordion.accordionToggle(true);
    return;
  }

  accordion.accordionToggle(false);
});

// mouseout
// $(document).on('mouseout','.js-accordion-button',function(){

// });

/* eslint-disable */
$(document).on("click", function (e) {
  const target = $(e.target);
  if (
    target.hasClass("js-accordion") ||
    target.parents(".js-accordion").length
  ) {
    return;
  }

  $(".js-accordion-close-on-click-outside.is-active").each(function () {
    $(this).accordionToggle(true);
  });
});
/* eslint-enable */
